import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmployeeService } from '../../services/employees.service';
import { UtilService } from '../../services/util.service';
import { Employee, Group } from '../../models/models';

@Component({
    selector: 'employee-popup',
    templateUrl: './employee-popup.component.html',
    standalone: false
})
export class EmployeePopup implements OnInit {
    @Input() initGroups: Group[] = [];
    @Input() initEmployees: Employee[] = [];
    @Input() extraEmails: string = "";
    @Output() employeesChanged: EventEmitter<Employee[]> = new EventEmitter<Employee[]>();
    @Output() groupIdChanged: EventEmitter<number> = new EventEmitter<number>();
    @Output() emailsChanged: EventEmitter<string> = new EventEmitter<string>();

    public employeeGroups: Group[] = [];
    public employees: Employee[] = [];
    public emails: string[] = [];
    public selectedGroupId: number = -1;
    public selectedEmployees: Employee[] = [];
    public selectedEmails: string = "";

    constructor(public employeeService: EmployeeService, private utilService: UtilService) {

    }

    ngOnInit() {
        //console.log("email-popup:ngOnInit:initEmployees", this.initEmployees);
        this.getEmployeeGroups();
        this.getEmployees();
        this.selectedEmails = this.extraEmails;
        if (this.selectedEmails != null && this.selectedEmails != "") {
            this.emailsChanged.emit(this.selectedEmails);
        }
    }

    private getEmployeeGroups() {
        this.employeeService.getAllEmployeeGroups().subscribe(result => {
            this.employeeGroups = result;
            if (this.initGroups && this.initGroups.length > 0) {
                this.selectedGroupId = this.initGroups[0].groupId;
            }
        });
    }

    private getEmployees() {
        this.utilService.isLoading = true;
        this.employeeService.getActiveEmployees().subscribe(result => {
            this.utilService.isLoading = false;
            this.employees = result;
            if (this.initEmployees && this.initEmployees.length > 0) {
                this.selectedEmployees = this.initEmployees;
                //console.log("email-popup:getEmployees:selectedEmployees", this.selectedEmployees);
            }
        });
    }

    public groupChanged(groupId) {
        this.groupIdChanged.emit(groupId);
    }

    public selectionChanged() {
        this.employeesChanged.emit(this.selectedEmployees);
    }

    public emailsOnChange(emails: string) {
        this.selectedEmails = emails;
        //console.log(this.selectedEmails, emails);
        this.emailsChanged.emit(this.selectedEmails);
    }
}

@Component({
    selector: 'employee-multiselect-dialog',
    templateUrl: './dialog.component.html',
    standalone: false
})
export class EmployeeMultiselectDialog {
    public selectedGroupId: number = 0;
    public selectedEmployees: Employee[] = [];
    public selectedEmails: string = "";
    public notes: string = '';
    public checkCallNotes: string = '';
    public systemNotes: string = '';
    public isEscalation: boolean = false;
    public isShowCancel: boolean = true;

    constructor(public dialogRef: MatDialogRef<EmployeeMultiselectDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.selectedEmployees = data.employees;
        if (data.showNotes == true) {
            this.notes = data.notes;
        }
        if (data.showCheckCallNotes == true) {
            this.checkCallNotes = data.checkCallNotes;
        }
        if (data.showSystemNotes == true) {
            this.systemNotes = data.systemNotes;
        }
        if (data.isEscalation && data.isEscalation == true) {
            this.isShowCancel = false;
        }
        //console.log("email-popup-dialog:constructor:selectedEmployees", this.selectedEmployees);
    }

    public employeeSelected(employees: Employee[]) {
        this.selectedEmployees = employees;
    }

    public groupSelected(groupId: number) {
        this.selectedGroupId = groupId;
    }

    public emailsSelected(emails: string) {
        this.selectedEmails = emails;
    }
    
    public select(): void {
        this.dialogRef.close({
            selectedEmployees: this.selectedEmployees,
            selectedGroupId: this.selectedGroupId,
            selectedEmails: this.selectedEmails,
            notes: this.notes,
            checkCallNotes: this.checkCallNotes,
            systemNotes: this.systemNotes
        });
    }

    public cancel(): void {
        this.dialogRef.close({
            selectedEmployees: null,
            selectedEmails: null,
            notes: null,
            checkCallNotes: null,
            systemNotes: null
        });
    }
}
